(ns frontend.ux-overhaul.listing.fund.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.fund.event :as fund-event]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "fund-listing")

(defn- open-fund!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/fund})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/fund
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :fund
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-fund
                                 :label    (loc/tr :fund-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-event/create-fund]}
                                {:id                  :bulk-edit-funds
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::fund-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-funds
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::fund-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-funds
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-funds-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::fund-event/export-grid-with-persons {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :funds)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.fund/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::fund-event/create-fund])
         :on-row-clicked           open-fund!
         :on-card-clicked          open-fund!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/fund}]])}))
